import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://f89c82e01644247c0542cedbcef9b6f1@o4507927506911232.ingest.us.sentry.io/4507927651483648",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()